import {Component, inject, Input, OnInit} from '@angular/core';
import {EntityConfig} from "@signature-it/ngx-generic/config";
import {Subscription} from "rxjs";
import {TemplateRef, ViewChild} from '@angular/core';
import {MatTabChangeEvent} from "@angular/material/tabs";
import {ActivatedRoute} from "@angular/router";
@Component({
    selector: 'content-tabs',
    templateUrl: './content-tabs.component.html',
    styleUrls: ['./content-tabs.component.scss'],
    standalone: false
})
export class ContentTabsComponentGeneric implements OnInit{
    @Input() key: string = 'default';
    @Input() displayByModes: boolean = false;
    @ViewChild('tab1') tab1:TemplateRef<any>;
    @ViewChild('tab2') tab2:TemplateRef<any>;
    @ViewChild('tab3') tab3:TemplateRef<any>;
    @ViewChild('tab4') tab4:TemplateRef<any>;
    @ViewChild('tab5') tab5:TemplateRef<any>;
    @ViewChild('tab6') tab6:TemplateRef<any>;
    @ViewChild('tab7') tab7:TemplateRef<any>;
    @ViewChild('tab8') tab8:TemplateRef<any>;
    @ViewChild('tab9') tab9:TemplateRef<any>;
    @ViewChild('tab10') tab10:TemplateRef<any>;
    @ViewChild('tab11') tab11:TemplateRef<any>;
    tabs = [];
    tabActiveMode: string = '';
    private route: ActivatedRoute = inject(ActivatedRoute);
    activeTabIndex: number = 0;

    async ngOnInit() {
        let configOptions = EntityConfig.ngxContentTabs;

        if (configOptions && this.key) {
            configOptions = configOptions[this.key];
            this.tabs = configOptions['tabs'];
            this.displayByModes = configOptions['displayByModes'];
            this.tabActiveMode = this.tabs[0]['displayMode'];
        }


        this.route.queryParams.subscribe(params => {
            const tabIndex = +params[`${this.key}-active`];
            if (tabIndex) {
                this.activeTabIndex = tabIndex;
            }
        });
    }
    tabChanged(tabChangeEvent: MatTabChangeEvent): void {
        if (this.displayByModes && this.tabs[tabChangeEvent.index]) {
            this.tabActiveMode = this.tabs[tabChangeEvent.index]['displayMode'];
        }
    }
}

